// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"65d4d1a8","120":"00733659","371":"1b54fdb1","410":"bd5a53e1","458":"bd31e162","512":"3d1df971","657":"50160d46","688":"8b2dbbd7","701":"50f80412","746":"68114c12","942":"cc66b676"}[chunkId] + ".chunk.js";
};